module.exports = __webpack_public_path__ + "img/GYLFW_1.5193a281.jpg";